export const FORGET_PASSWORD_BEGIN = "FORGET_PASSWORD_BEGIN";
export const FORGET_PASSWORD_FAIL = "FORGET_PASSWORD_FAIL";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
